import apps from './apps';
import dashboard from './home';
import more from './other';

const navigation = [...dashboard, ...apps, ...more];

export default navigation;
